import { createSelector } from 'reselect'
import { isBedbankItem } from 'lib/checkout/checkoutUtils'
import moment from 'moment'
import { ISO_DATE_FORMAT } from 'constants/dateFormats'
import getBedbankChangeDatePriceDiff from 'checkout/selectors/view/getBedbankChangeDatePriceDiff'

function mapItemType(item: App.Checkout.AnyItem): string {
  if (isBedbankItem(item)) {
    return 'bedbank'
  }
  return item.itemType
}

const getPaymentScheduleAdjustmentRequestInfo = createSelector(
  (state: App.State) => state.checkout.cart.existingOrder,
  (state: App.State) => state.checkout.cart.items,
  (state: App.State) => state.geo.currentCurrency,
  getBedbankChangeDatePriceDiff,
  (
    existingOrder,
    cartItems,
    currency,
    bedbankChangeDatePriceDiff,
  ): App.Checkout.PaymentScheduleAdjustmentRequestInfo | null => {
    if (!existingOrder) {
      return null
    }

    if (cartItems.length !== 1) {
      return null
    }

    if (!isBedbankItem(cartItems[0])) {
      return null
    }

    const bedbankItem = cartItems[0]

    const startDate = bedbankItem.checkIn

    if (!startDate) {
      return null
    }

    const adjustedItem = {
      idItems: bedbankItem.orderItemId ?? undefined,
      adjustmentAmount: bedbankChangeDatePriceDiff,
      type: mapItemType(bedbankItem),
    }

    if (adjustedItem.idItems === undefined) {
      return null
    }

    return {
      orderId: existingOrder.id,
      bookingInfo: {
        bookingDate: moment().format(ISO_DATE_FORMAT),
        checkinDate: startDate,
        currency,
        idItems: adjustedItem.idItems,
        adjustmentAmount: adjustedItem.adjustmentAmount,
      },
    }
  },
)

export default getPaymentScheduleAdjustmentRequestInfo
